import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../CookieAuth/auth.service';
import { Direccion } from '../interfaces/direccion';
import { ConfHttpService } from './conf-http.service';

@Injectable({
  providedIn: 'root'
})
export class DireccionService {
  endpopint:string='';
  headers:HttpHeaders = new HttpHeaders({'Content-Type': 'application/json'});
  constructor(private http:HttpClient, private cookie: AuthService, conf:ConfHttpService) {
    this.endpopint=conf.getBackend();
   }
  get(id:number){
    return this.http.get<any>(this.endpopint+'getdirecciones/'+ id,{headers: this.headers}).toPromise();
  }
  getByCliente(){
    return this.http.get<any>(this.endpopint+'getdireccionesbycliente/'+ this.cookie.getCookie(),{headers: this.headers}).toPromise();
  }
  post(direccion:Direccion){
    return this.http.post<any>(this.endpopint+'postdireccion',direccion,{headers: this.headers}).toPromise();
  }


}
